<div class="wrong-image-modal">
    <h2>Only JPEG and PNG image formats allowed</h2>
</div>